import React from 'react'
import "./Get_App.css"
import { Link } from 'react-router-dom'

function Get_App() {
    return (
        <>
            <section className='Get_App margin_section'>
                <Link to={"https://play.google.com/"} target='_blank'>
                    <div className='img_holder'>
                        <img src="/assets/images/get_app/Get_App.png" alt="Get App" className='Get_App_img' />
                    </div>
                </Link>
            </section>
        </>
    )
}

export default Get_App